import React, { useState } from "react";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

// import JS files
import MuiPagination from "../../../shares/MuiPagination";
import OrderDetails from "./OrderDetails";
import PanelTable from "../../../shares/PanelTable";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTemplate from "../../../shares/PanelTemplate";
import { useUserData } from "../../../../context/UserDataContext";
import useFetch from "../../../../context/useFetch";
import PrintIcon from "@mui/icons-material/Print";
import MuiButton from "../../../shares/MuiButton";
import AdminPrintCompleteOrderiInfo from "./AdminPrintNeedConfirmedOrderiInfo";
import ChangeOrderState from "./ChangeOrderState";
import AdminPrintNeedConfirmedOrderiInfo from "./AdminPrintNeedConfirmedOrderiInfo";

const headersList = [
  { colName: "unique_id", name: " سند" },
  { colName: "name", name: "تولید کننده" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن" },
  { colName: "details", name: "جزییات سفارش" },
  // { colName: "remove", name: "لغو سفارش" },
  { colName: "change_state", name: "تایید / رد سفارش" },

  { colName: "print", name: "چاپ سفارش" },
];
const mobileHeadersList = [
  { colName: "name", name: "مشتری" },
  { colName: "unique_id", name: " سند" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن" },
];
const dataKey = ["unique_id", "name", "created_at", "total"];

const AdminProviderNeedConfirmedOrder = (props) => {
  let windowWidth = window.screen.width;

  const [codeFilter, setCodeFilter] = useState(null);
  const [dateFilter, setDateFilter] = useState(null);
  const [brandFilter, setBrandFilter] = useState(null);
  const [isFilterOn, setIsFilterOn] = useState(false);
  const [selectedRow, setSelectedRow] = useState(undefined);
  const { userData } = useUserData();
  const [storeFilter, setStoreFilter] = useState(null);

  const [brandsList, setBrandsList] = useState({ results: [] });
  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });
  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",

    trigger: true,
    pagination: brandPagination,
    setter: setBrandsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const filterList = [
    {
      type: "textField",
      label_fa: "کد سفارش",
      label_en: "code",
      state: codeFilter,
    },
    {
      type: "textField",
      label_fa: "نام تولید کننده",
      label_en: "storeName",
      state: storeFilter,
    },
    {
      type: "datePicker",
      label_fa: "تاریخ ثبت سفارش",
      label_en: "date",
      state: dateFilter,
    },
  ];

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });
  const [currentOrdersList, setCurrentOrdersList] = useState({ results: [] });

  const adminGetProviderCurrentOrderApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/admin_get_need_confirmed_provider_request`,
    params: {
      unique_id: codeFilter,
      date: dateFilter,
      provider_name: storeFilter,
    },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setCurrentOrdersList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "date") setDateFilter(e.length > 0 ? e : null);
    if (state == "storeName") setStoreFilter(e.length > 0 ? e : null);
  };
  const filter = () => {
    if (codeFilter !== null || dateFilter !== null || storeFilter !== null) {
      setIsFilterOn(true);
      adminGetProviderCurrentOrderApi.reFetch();
    }
  };
  const reset_filter = () => {
    setCodeFilter(null);
    setDateFilter(null);
    setStoreFilter(null);
    adminGetProviderCurrentOrderApi.reFetch();
  };

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    // setCurrentOrdersList({ results: [] });

    adminGetProviderCurrentOrderApi.reFetch();
  };

  const actionsList = [
    {
      label: "تایید / رد سفارش",
      component: (it) => (
        <ChangeOrderState
          selectedRow={it}
          adminGetCustomerReceviedOrderApi={adminGetProviderCurrentOrderApi}
        />
      ),
    },
    {
      label: "چاپ",
      component: (it) => (
        <AdminPrintNeedConfirmedOrderiInfo inCurrentOrder selectedRow={it} />
      ),
    },
  ];

  const buttonsList = [
    {
      label: "جزییات سفارش",
      component: (it) => (
        <OrderDetails
          // setNewOerdersList={setWaitingOrdersList}
          selectedRow={it}
          adminGetProviderCurrentOrderApi={adminGetProviderCurrentOrderApi}
        />
      ),
    },
  ];

  const handelPrintReport = () => {
    // navigate(
    //   `/print-customers-current-orders-by-customer/${codeFilter}/${storeFilter}/${dateFilter}/${cityFilter}`
    // );
    window.open(
      `/print-providers-need-confirmed-orders/${codeFilter}/${storeFilter}/${dateFilter}`,
      "_blank"
      // "rel=noopener noreferrer"
    );
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink="p-need-confirmed-orders">
        <>
          <div className="panel-main-header">
            <span>سفارش‌های منتظر تایید</span>
          </div>
          <PanelFilter
            header="فیلتر سفارش‌ها:"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <div className="flex justify-end">
            <MuiButton
              onClick={handelPrintReport}
              variant="outlined"
              icon={<PrintIcon />}
              color="primary"
              text="چاپ گزارش"
              margin="mr-2"
            />
          </div>
          <PanelTable
            header="لیست سفارش‌های تحویل گرفته شده:"
            headers={headersList}
            mobileHeaders={mobileHeadersList}
            data={currentOrdersList.results}
            dataKey={dataKey}
            buttons={buttonsList}
            actions={actionsList}
            icon={<AccountBalanceIcon />}
          />
          <MuiPagination
            onChange={onChangePage}
            count={Math.ceil(
              paginationPageInfo.count / paginationPageInfo.pageSize
            )}
          />
        </>
      </PanelTemplate>
    </>
  );
};

export default AdminProviderNeedConfirmedOrder;
